import _ from 'lodash';
import veritoneApi from './veritoneApi';
import  { AD_TYPE_ID, SUMMARY_DATA_NUM_WEEKS } from './constant';
import { convertdate } from './formatData';
import { mergeData } from '../helpers/common'


const LIMIT_CHUNKS_MENTIONS = 50000;

const formatAdSourceQuery = (adSources) => {
    if(!adSources) {
        return '';//get all adSources
    }
    if (adSources.length === 0) {
        return '&adSources[]=';//unselect all adSources
    }
    return adSources.reduce((acc, adSource) => `${acc}&adSources[]=${adSource}`, '');
}

export function getChartData({
  urlApi, 
  advertiserId, 
  campaignId, 
  chartId, 
  startDate, 
  endDate, 
  adSources
}) {
    const adSourcesQuery = formatAdSourceQuery(adSources);
    return veritoneApi(urlApi.baseUrl)
        .get(`/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}${adSourcesQuery}`)
        .then(response => response.data)
        .catch(error => error)
}

export function getDeviceCategoryChartData({
    urlApi, 
    campaignId, 
    startDate, 
    endDate
}) {
    return veritoneApi(urlApi.baseUrl)
        .get(`/campaign/device_category/${campaignId}?startDate=${startDate}&endDate=${endDate}`)
        .then(response => response.data)
        .catch(error => error)
}

export function getPagePathChartData({
    urlApi, 
    campaignId, 
    startDate, 
    endDate
}) {
    return veritoneApi(urlApi.baseUrl)
        .get(`/campaign/page_tracker/${campaignId}?startDate=${startDate}&endDate=${endDate}`)
        .then(response => response.data)
        .catch(error => error)
}


/*
 * Make get traffic chart data pai calls in chunks, then aggregate the data.
 */

export function getTrafficChanelChartData({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
}) {
return new Promise(async (resolve, reject) => {
  try {
    const result = await fetchTrafficChartDataInChunks({
        urlApi,
        advertiserId,
        campaignId,
        chartId,
        startDate,
        endDate,
        adSources,
   });
    resolve(result);
  } catch (error) {
    reject({});
  }
});
}

async function fetchTrafficChartDataInChunks({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
  pageIndex
}) {
let fetchedResults = {};
const adSourcesQuery = formatAdSourceQuery(adSources);
const calculatePageIndex = pageIndex ? pageIndex : 1;
try {
  const response = await veritoneApi(urlApi.baseUrl).get(
      `/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}${adSourcesQuery}&pageIndex=${calculatePageIndex}&limit=${LIMIT_CHUNKS_MENTIONS}`
  );
  fetchedResults = _.get(response, "data", {});
} catch (error) {
  //Skip Bad Request (For Now)
}

const nextPageIndex  = _.get(fetchedResults, "nextPageIndex", 1);
const currentPageIndex  = _.get(fetchedResults, "currentPageIndex", 1);

if (nextPageIndex !== 1 && currentPageIndex < nextPageIndex) {

  const nextResults = await fetchTrafficChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources,
      pageIndex: nextPageIndex,
 });
  //Merge Data
  const nextData = _.get(nextResults, "data", {});
  const fetchedData = _.get(fetchedResults, "data", {});
  const getItemById = (item, id) => item.find(item => item.trafficId === id);
  const newIdHashMap = nextData.map(item => item.trafficId);
  const fetchedIdHashMap = fetchedData.map(item => item.trafficId);
  const uniqIdHashMap = _.union(newIdHashMap, fetchedIdHashMap);
  const mergedData = uniqIdHashMap.map(id => {
    const baseResult = getItemById(fetchedData, id);
    const newData = getItemById(nextData, id);
    let aggreateItem = {...baseResult};
    const keys = ['adUsers', 'adVisits', 'newAdUsers', 'sumAvgAdCost', 'ads'];
    if (!newData) {
      aggreateItem = baseResult;
    } else if(!baseResult) {
      aggreateItem = newData;
    } else {
      aggreateItem = mergeData({ baseResult, newData, keys });
    }
    return aggreateItem;
  })

  if(currentPageIndex + 1 === nextPageIndex) {
    mergedData.forEach(item => {
        item.avgAdCost = item.sumAvgAdCost ? Number(item.sumAvgAdCost / item.ads) : null;
    })
  }

  const mergedResult = { ...nextResults };
  mergedResult.data = mergedData;
  return mergedResult;
} else {
  return fetchedResults;
}
}

/*
 * Make get creative chart data pai calls in chunks, then aggregate the data.
 */

export function getStationChartData({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
}) {
return new Promise(async (resolve, reject) => {
  try {
    const result = await fetchStationChartDataInChunks({
        urlApi,
        advertiserId,
        campaignId,
        chartId,
        startDate,
        endDate,
        adSources,
  });
    resolve(result);
  } catch (error) {
    reject({});
  }
});
}
async function fetchStationChartDataInChunks({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
  pageIndex,
}) {
let fetchedResults = {};
const adSourcesQuery = formatAdSourceQuery(adSources);
const calculatePageIndex = pageIndex ? pageIndex : 1;
try {
  const response = await veritoneApi(urlApi.baseUrl).get(
      `/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}${adSourcesQuery}&pageIndex=${calculatePageIndex}&limit=${LIMIT_CHUNKS_MENTIONS}`
  );
  fetchedResults = _.get(response, "data", {});
} catch (error) {
  //Skip Bad Request (For Now)
}

const nextPageIndex  = _.get(fetchedResults, "nextPageIndex", 1);
const currentPageIndex  = _.get(fetchedResults, "currentPageIndex", 1);

if (nextPageIndex !== 1 && currentPageIndex < nextPageIndex) {

  const nextResults = await fetchStationChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources,
      pageIndex: nextPageIndex,
  });
  //Merge Data
  const nextData = _.get(nextResults, "data", {});
  const fetchedData = _.get(fetchedResults, "data", {});
  const getItemById = (item, id) => item.find(item => item.stationId === id);
  const fetchedIdHashMap = fetchedData.map(item => item.stationId);
  const newIdHashMap = nextData.map(item => item.stationId);
  const uniqIdHashMap = _.union(newIdHashMap, fetchedIdHashMap);
  const mergedData = uniqIdHashMap.map(id => {
    const baseResult = getItemById(fetchedData, id);
    const newData = getItemById(nextData, id);
    let aggreateItem = {...baseResult};
    const keys = ['adUser', 'adVisit', 'aired', 'newAdUsers', 'numPricedAds', 'sumAvgAdCost', 'totalAdCost'];
  
    if (!newData) {
      aggreateItem = baseResult;
    } else if(!baseResult) {
      aggreateItem = newData;
    } else {
      aggreateItem = mergeData({ baseResult, newData, keys });
    }
    return aggreateItem;
  })

  if(currentPageIndex + 1 === nextPageIndex) {
    mergedData.forEach(item => {
        item.visitOfads = parseFloat(item.adVisit / item.aired).toFixed(2);
        item.visitOfads = parseFloat(item.visitOfads);
        item.avgAdCost = item.numPricedAds ? Number(item.sumAvgAdCost / item.numPricedAds) : null;
    })
  }

  const mergedResult = { ...nextResults };
  mergedResult.data = mergedData;
  return mergedResult;
} else {
  return fetchedResults;
}
}
/*
 * Make get creative chart data pai calls in chunks, then aggregate the data.
 */

export function getCreativeChartData({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources
}) {
return new Promise(async (resolve, reject) => {
  try {
    const result = await fetchCreativeChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources
   });
    resolve(result);
  } catch (error) {
    reject({});
  }
});
}
async function fetchCreativeChartDataInChunks({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
  pageIndex
}) {
let fetchedResults = {};
const adSourcesQuery = formatAdSourceQuery(adSources);
const calculatePageIndex = pageIndex ? pageIndex : 1;
try {
  const response = await veritoneApi(urlApi.baseUrl).get(
      `/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}${adSourcesQuery}&pageIndex=${calculatePageIndex}&limit=${LIMIT_CHUNKS_MENTIONS}`
  );
  fetchedResults = _.get(response, "data", {});
} catch (error) {
  //Skip Bad Request (For Now)
}

const nextPageIndex  = _.get(fetchedResults, "nextPageIndex", 1);
const currentPageIndex  = _.get(fetchedResults, "currentPageIndex", 1);

if (nextPageIndex !== 1 && currentPageIndex < nextPageIndex) {

  const nextResults = await fetchCreativeChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources,
      pageIndex: nextPageIndex,
  });
  //Merge Data
  const nextData = _.get(nextResults, "data", {});
  const fetchedData = _.get(fetchedResults, "data", {});
  const getItemById = (item, id) => item.find(item => item.creative_name === id);
  const fetchedIdHashMap = fetchedData.map(item => item.creative_name);
  const newIdHashMap = nextData.map(item => item.creative_name);
  const uniqIdHashMap = _.union(newIdHashMap, fetchedIdHashMap);
  const mergedData = uniqIdHashMap.map(id => {
    const baseResult = getItemById(fetchedData, id);
    const newData = getItemById(nextData, id);
    let aggreateItem = {...baseResult};
    const keys = ['adUser', 'aired', 'newAdUsers', 'pricedAds', 'sumAvgAdCost', 'station_name'];

    if (!newData) {
      aggreateItem = baseResult;
    } else if(!baseResult) {
      aggreateItem = newData;
    } else {
      aggreateItem = mergeData({ baseResult, newData, keys });
    }
    return aggreateItem;
  })

  if(currentPageIndex + 1 === nextPageIndex) {
    mergedData.forEach(item => {
        item.visitOfads = parseFloat(item.visits / item.aired).toFixed(2);
        item.visitOfads = parseFloat(item.visitOfads);
        item.avgAdCost = item.sumAvgAdCost !== null ? Number(item.sumAvgAdCost / item.pricedAds) : null;
    })
  }

  const mergedResult = { ...nextResults };
  mergedResult.data = mergedData;
  return mergedResult;
} else {
  return fetchedResults;
}
}


/*
 * Make get daypart chart data pai calls in chunks, then aggregate the data.
 */

export function getDayPartChartData({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
}) {
return new Promise(async (resolve, reject) => {
  try {
    const result = await fetchDayPartChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources,
   });
    resolve(result);
  } catch (error) {
    reject({});
  }
});
}
async function fetchDayPartChartDataInChunks({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
  pageIndex,
 }) {
let fetchedResults = {};
const adSourcesQuery = formatAdSourceQuery(adSources);
const calculatePageIndex = pageIndex ? pageIndex : 1;
try {
  const response = await veritoneApi(urlApi.baseUrl).get(
      `/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}${adSourcesQuery}&pageIndex=${calculatePageIndex}&limit=${LIMIT_CHUNKS_MENTIONS}`
  );
  fetchedResults = _.get(response, "data", {});
} catch (error) {
  //Skip Bad Request (For Now)
}

const nextPageIndex  = _.get(fetchedResults, "nextPageIndex", 1);
const currentPageIndex  = _.get(fetchedResults, "currentPageIndex", 1);

if (nextPageIndex !== 1 && currentPageIndex < nextPageIndex) {

  const nextResults = await fetchDayPartChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources,
      pageIndex: nextPageIndex,
  });
  //Merge Data
  const nextDataByDate = _.get(nextResults, 'data.byDate' , {});
  const fetchedDataByDate = _.get(fetchedResults, 'data.byDate' , {});
  const keys = ['adVisit', 'ads', 'newAdUsers', 'pricedAds', 'sumAvgAdCost', 'user'];
  const getItemById = (item, id) => item.find(item => item.time === id);
  const fetchedIdByDateHashMap = fetchedDataByDate.map(item => item.time);
  const newIdByDateHashMap = nextDataByDate.map(item => item.time);
  const uniqIdByDateHashMap = _.union(newIdByDateHashMap, fetchedIdByDateHashMap);
  const mergedDataByDate = uniqIdByDateHashMap.map(id => {
    const baseResult = getItemById(fetchedDataByDate, id);
    const newData = getItemById(nextDataByDate, id);
    let aggreateItem = {...baseResult};
    if (!newData) {
      aggreateItem = baseResult;
    } else if(!baseResult) {
      aggreateItem = newData;
    } else {
      aggreateItem = mergeData({ baseResult, newData, keys });
    }
    return aggreateItem;
  })

  const nextDataByHour = _.get(nextResults, 'data.byHour' , {});
  const fetchedDataByHour = _.get(fetchedResults, 'data.byHour' , {});
  const newIdByHourHashMap = nextDataByHour.map(item => item.time);
  const fetchedIdByHourHashMap = fetchedDataByHour.map(item => item.time);
  const uniqIdByHourHashMap = _.union(newIdByHourHashMap, fetchedIdByHourHashMap);
  const mergedDataByHour = uniqIdByHourHashMap.map(id => {
    const baseResult = getItemById(fetchedDataByHour, id);
    const newData = getItemById(nextDataByHour, id);
    let aggreateItem = {...baseResult};
    if (!newData) {
      aggreateItem = baseResult;
    } else if(!baseResult) {
      aggreateItem = newData;
    } else {
      aggreateItem = mergeData({ baseResult, newData, keys });
    }
    return aggreateItem;
  })

  if(currentPageIndex + 1 === nextPageIndex) {
    mergedDataByHour.forEach(item => {
        item.avgAdCost = item.sumAvgAdCost !== null ? Number(item.sumAvgAdCost / item.pricedAds) : null;
    })
    mergedDataByDate.forEach(item => {
      item.avgAdCost = item.sumAvgAdCost !== null ? Number(item.sumAvgAdCost / item.pricedAds) : null;
  })
  }

  const mergedResult = { ...nextResults };
  mergedResult.data.byDate = mergedDataByDate;
  mergedResult.data.byHour = mergedDataByHour;
  return mergedResult;
} else {
  return fetchedResults;
}
}


/*
 * Make get advisits by week chart data pai calls in chunks, then aggregate the data.
 */

export function getAdVisitByWeekChartData({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources
}) {
return new Promise(async (resolve, reject) => {
  try {
    const result = await fetchAdVisitByWeekChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources
    });
    resolve(result);
  } catch (error) {
    reject({});
  }
});
}
async function fetchAdVisitByWeekChartDataInChunks({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
  pageIndex
}) {
let fetchedResults = {};
const adSourcesQuery = formatAdSourceQuery(adSources);
const calculatePageIndex = pageIndex ? pageIndex : 1;
try {
  const response = await veritoneApi(urlApi.baseUrl).get(
      `/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}${adSourcesQuery}&pageIndex=${calculatePageIndex}&limit=${LIMIT_CHUNKS_MENTIONS}`
  );
  fetchedResults = _.get(response, "data", {});
} catch (error) {
  //Skip Bad Request (For Now)
}

const nextPageIndex  = _.get(fetchedResults, "nextPageIndex", 1);
const currentPageIndex  = _.get(fetchedResults, "currentPageIndex", 1);

if (nextPageIndex !== 1 && currentPageIndex < nextPageIndex) {

  const nextResults = await fetchAdVisitByWeekChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources,
      pageIndex: nextPageIndex,
  });
  //Merge Data
  const nextData = _.get(nextResults, "data", {});
  const fetchedData = _.get(fetchedResults, "data", {});
  const getItemById = (item, keys) => item.find(item => item.hour === keys[0] && item.weekday === keys[1]);
  const newIdHashMap = nextData.map(item => [item.hour, item.weekday]);
  const fetchedIdHashMap = fetchedData.map(item => [item.hour, item.weekday]);
  const uniqIdHashMap = _.union(newIdHashMap, fetchedIdHashMap);
  const mergedData = uniqIdHashMap.map(key => {
    const baseResult = getItemById(fetchedData, key);
    const newData = getItemById(nextData, key);
  let aggreateItem = {...baseResult};
  const keys = ['adUser', 'adVisit', 'ads', 'newAdUsers', 'user'];

  if (!newData) {
    aggreateItem = baseResult;
  } else if(!baseResult) {
    aggreateItem = newData;
  } else {
    aggreateItem = mergeData({ baseResult, newData, keys });
  }
  return aggreateItem;
})

  const mergedResult = { ...nextResults };
  mergedResult.data = mergedData;
  return mergedResult;
} else {
  return fetchedResults;
}
}

export function getChartDataWebAnalyticsCompare(urlApi, advertiserId, campaignId, chartId, startDate, endDate, startDateTimeSecondary, endDateTimeSecondary, adSources) {
    const adSourcesQuery = formatAdSourceQuery(adSources);
    return veritoneApi(urlApi.baseUrl)
        .get(`/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}&startDateTimeSecondary=${startDateTimeSecondary}&endDateTimeSecondary=${endDateTimeSecondary}${adSourcesQuery}`)
        .then(response => response.data)
        .catch(error => error)
}

export function getPerformanceSummaryChartData(urlApi, advertiserId, campaignId, chartId, campaignStartDate, campaignEndDate, compareStartDate, compareEndDate, adSources) {
    const adSourcesQuery = formatAdSourceQuery(adSources);
    return veritoneApi(urlApi.baseUrl)
            .get(`/advertiser/${advertiserId}/data/${campaignId}?chartIds=${chartId}&startDate=${campaignStartDate}&endDate=${campaignEndDate}&customStartDate=${compareStartDate}&customEndDate=${compareEndDate}${adSourcesQuery}`)
            .then(response => response.data)
            .catch(error => error);
}

//------------------------------------------------------------------------------------------------------------------------
//----------------------------------Load Geofence Data Function & Support Functions---------------------------------------
//------------------------------------------------------------------------------------------------------------------------
export function getAggregateGeofencingData({
    urlApi, 
    campaignId, 
    startDate, 
    endDate, 
    adSources, 
    location
}) {
    const adSourcesQuery = formatAdSourceQuery(adSources);
    const queryParam = { startDate, endDate };

    if (location) {
        queryParam.location = location;
    }
    const searchParams = new URLSearchParams(queryParam).toString();
    return new Promise(async (resolve, reject) => {
        try {
            const response = await veritoneApi(urlApi.baseUrl).get(`/campaign/geo/${campaignId}?${searchParams}${adSourcesQuery}`);
            const result = _.get(response, 'data', {});
            resolve(result);
        } catch (error) {
            reject({});
        }
    });
}

/*
 * Make get advisits by week chart data pai calls in chunks, then aggregate the data.
 */

export function getAdTypeChartData({
    urlApi,
    advertiserId,
    campaignId,
    chartId,
    startDate,
    endDate,
    adSources,
}) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await fetchAdTypeChartDataInChunks({
          urlApi,
          advertiserId,
          campaignId,
          chartId,
          startDate,
          endDate,
          adSources
    });
      resolve(result);
    } catch (error) {
      reject({});
    }
  });
}


async function fetchAdTypeChartDataInChunks({
  urlApi,
  advertiserId,
  campaignId,
  chartId,
  startDate,
  endDate,
  adSources,
  pageIndex,
}) {
let fetchedResults = {};
const adSourcesQuery = formatAdSourceQuery(adSources);
const calculatePageIndex = pageIndex ? pageIndex : 1;
try {
  const response = await veritoneApi(urlApi.baseUrl).get(
      `/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}${adSourcesQuery}&pageIndex=${calculatePageIndex}&limit=${LIMIT_CHUNKS_MENTIONS}`
  );
  fetchedResults = _.get(response, "data", {});
} catch (error) {
  //Skip Bad Request (For Now)
}

const nextPageIndex  = _.get(fetchedResults, "nextPageIndex", 1);
const currentPageIndex  = _.get(fetchedResults, "currentPageIndex", 1);

if (nextPageIndex !== 1 && currentPageIndex < nextPageIndex) {

  const nextResults = await fetchAdTypeChartDataInChunks({
      urlApi,
      advertiserId,
      campaignId,
      chartId,
      startDate,
      endDate,
      adSources,
      pageIndex: nextPageIndex,
  });
  //Merge Data
  const nextData = _.get(nextResults, "data", {});
  const fetchedData = _.get(fetchedResults, "data", {});
  const getItemById = (item, id) => item.find(item => item.type_id === id);
  const fetchedIdHashMap = fetchedData.map(item => item.type_id);
  const newIdHashMap = nextData.map(item => item.type_id);
  const uniqIdHashMap = _.union(newIdHashMap, fetchedIdHashMap);
  const mergedData = uniqIdHashMap.map(id => {
    const baseResult = getItemById(fetchedData, id);
    const newData = getItemById(nextData, id);
    let aggreateItem = {...baseResult};
    const keys = ['aired', 'adVisit', 'adUser', 'pricedAds', 'sumAvgAdCost'];

    if (!newData) {
      aggreateItem = baseResult;
    } else if(!baseResult) {
      aggreateItem = newData;
    } else {
      aggreateItem = mergeData({ baseResult, newData, keys });
    }
    return aggreateItem;
  })

  if(currentPageIndex + 1 === nextPageIndex) {
    mergedData.forEach(item => {
        item.visitOfads = parseFloat(item.adVisit / item.aired).toFixed(2);
        item.visitOfads = parseFloat(item.visitOfads);
        item.avgAdCost = item.sumAvgAdCost !== null ? Number(item.sumAvgAdCost / item.pricedAds) : null;
    })
  }

  const mergedResult = { ...nextResults };
  mergedResult.data = mergedData;
  return mergedResult;
} else {
  return fetchedResults;
}
}

/**
 * Recursivly merge children, grand children... arrays
 * @param {Array} base 
 * @param {Array} addition 
 */
function mergeGeoChildren(base, addition) {
    if (!base && !addition) {
        return undefined;
    }else if (!base || base.length === 0) {
        return addition;
    } else if (!addition || addition.length === 0) {
        return base;
    }

    //Convert base children to HashMap for accessibility
    const baseHashMap = base.reduce((accumulator, entry) => {
        accumulator[entry.criterial_id] = entry;
        return accumulator;
    }, {});

    //Merge sub-regions data
    addition.forEach(additionalEntry => {
        const entryId = additionalEntry.criterial_id;
        if(!baseHashMap[entryId]) {                         //Entry doesn't exist
            baseHashMap[entryId] = additionalEntry;         //Insert new entry
        } else {                                            //Found an existing entry.
            const baseEntry = {...baseHashMap[entryId]};
            baseHashMap[entryId].ads = baseEntry.ads + additionalEntry.ads;
            baseHashMap[entryId].visits = baseEntry.visits + additionalEntry.visits;
            baseHashMap[entryId].new_users = baseEntry.new_users + additionalEntry.new_users;
            baseHashMap[entryId].totalCost = (baseEntry.totalCost == null && additionalEntry.totalCost == null) ? null : (baseEntry.totalCost + additionalEntry.totalCost);
            baseHashMap[entryId].pricedAds = (baseEntry.pricedAds || 0) + (additionalEntry.pricedAds || 0);
            baseHashMap[entryId].uniqueAds = (baseEntry.uniqueAds || 0) + (additionalEntry.uniqueAds || 0);
            if (baseEntry.children && additionalEntry.children) {
                //Merge grand children, great grand children...
                baseHashMap[entryId].children = mergeGeoChildren(baseEntry.children, additionalEntry.children)
            }
        }
    });

    return Object.values(baseHashMap);
}
//------------------------------------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------------------------------------

export function getDataDrillDownApi(urlApi, campaignId, drilldownInfo) {
    const {
        adType,
        startDate,
        endDate,
        creativeDuration,
        creativeName,
        stationId,
        locationId = '',
        geoType = '',
        adSources,
        hours='',
        trafficIds = [],
        usedTimezone = true,
        stationName=''
    } = drilldownInfo;
    const type = adType ? AD_TYPE_ID[adType] : Object.values(AD_TYPE_ID).toString();
    const idOfStation = stationId ? stationId : "";
    const encodedCreativeDuration = encodeURIComponent(creativeDuration);
    const creativeNameEncoded = encodeURIComponent(creativeName);
    const adSourcesQuery = formatAdSourceQuery(adSources);
    const trafficQuery = trafficIds.reduce((accum, trafficId)=> {
        return `${accum}&trafficIds[]=${trafficId}`;
    }, '');
    return veritoneApi(urlApi.baseUrl)
        .get( `/campaign/${campaignId}/search?searchType=${type}&startDate=${startDate}&endDate=${endDate}&duration=${encodedCreativeDuration}&creativeName=${creativeNameEncoded}&stationId=${idOfStation}&locationId=${locationId}&selectionType=${geoType}${adSourcesQuery}&hour=${hours}&usedTimezone=${usedTimezone}${trafficQuery}&stationName=${stationName}`)
        .then(response => _.get(response, 'data.data', []))
        .catch(() => [])
}

export function getCampaignSummaryData(urlApi, campaignId, startDate, endDate, adSources) {
    const adSourcesQuery = formatAdSourceQuery(adSources);
    const promises = getCampaignSummaryDataPromises(urlApi, campaignId, startDate, endDate, adSourcesQuery);
 
    return Promise.all(promises)
        .then(response => {
            if (response.data) {
                return response.data;                
            } else {
                // Aggregate data from numerous getCampaignSummaryData promises
                let aggregateData = {
                    adVisit: 0,
                    avgAdCost: 0,                   
                    newUsers: 0,
                    numPricedAds: 0,
                    totalAdCost: 0,
                    totalAdUsers: 0,
                    totalAds: 0,
                    totalUser: 0,
                    totalVisit: 0,
                    totalVisitWithAds: 0,
                    geoType: _.get(response, '0.data.geoType', null),
                    code: _.get(response, '0.data.code', null),
                    avgIndustryLift: _.get(response, '0.data.avgIndustryLift', null),
                    totalNewUsers: 0,
                    dayWithAds: 0,
                    dayWithoutAds: 0,
                }

                for (const r of response) {
                    const data = r.data;
                    aggregateData.adVisit += data.adVisit || 0;
                    aggregateData.newUsers += data.newUsers || 0;
                    aggregateData.numPricedAds += data.numPricedAds || 0;
                    aggregateData.totalAdCost += data.totalAdCost || 0;
                    aggregateData.totalAdUsers += data.totalAdUsers || 0;
                    aggregateData.totalAds += data.totalAds || 0;
                    aggregateData.totalUser += data.totalUser || 0;
                    aggregateData.totalVisit += data.totalVisit || 0;
                    aggregateData.totalVisitWithAds += data.totalVisitWithAds || 0;
                    aggregateData.totalNewUsers += data.totalNewUsers || 0;
                    aggregateData.dayWithAds += data.dayWithAds || 0;
                    aggregateData.dayWithoutAds += data.dayWithoutAds || 0;

                    if (Array.isArray(data.adSources) && data.adSources.length > 0) {
                        if(aggregateData.adSources) {
                            aggregateData.adSources = [...new Set([...aggregateData.adSources, ...data.adSources])];
                         } else {
                            aggregateData.adSources = data.adSources;
                         }
                    } 
                }                

                if(aggregateData.numPricedAds > 0) {
                    aggregateData.avgAdCost = Number((aggregateData.totalAdCost/aggregateData.numPricedAds).toFixed(2));
                }

                return aggregateData;
            }
        })
        .catch(error => error)
}

/* 
 * Returns an array of promises that fetch summaryData 
 *
 * Calls to get summaryData api are broken into several api calls.
 * Each api call has a startDate and endDate span that does not exceed ${SUMMARY_DATA_NUM_WEEKS} weeks
*/ 

function getCampaignSummaryDataPromises(urlApi, campaignId, startDate, endDate, adSourcesQuery) {
    // Safari's Date constructor treats dates with '-' as invalid dates
    const timeWindows = getChunkedTimeWindows(startDate, endDate);
    let promises = [];

    for (const tw of timeWindows){
        const promise = veritoneApi(urlApi.baseUrl)
            .get(`/campaign/${campaignId}/summaryData?startDate=${tw.startString}&endDate=${tw.endString}${adSourcesQuery}`)
        promises.push(promise);
    }    

    return promises;
}

function getChunkedTimeWindows(startDate, endDate) {
    // Safari's Date constructor treats dates with '-' as invalid dates
    const sd = startDate.replace(/-/g, '/');  
    const ed = endDate.replace(/-/g, '/');

    let startDT = new Date(sd);    
    const endDT = new Date(ed);

    const oneWeekMilliseconds = 604800000; //7 * 24 * (1000 * 60 * 60);
    let results = [];

    while (startDT < endDT) {
        const fromDateString = convertdate(startDT, true);
        let toDateString = endDate;
    
        // If we have more than ${SUMMARY_DATA_NUM_WEEKS} left, then we update the 'toDateString' date to ${SUMMARY_DATA_NUM_WEEKS} later, minus a second 
        if ((endDT - startDT) > (oneWeekMilliseconds * SUMMARY_DATA_NUM_WEEKS)) {
            let toDate = new Date(startDT.valueOf());
            toDate = addWeeksToDate(toDate, SUMMARY_DATA_NUM_WEEKS);
            toDate.setSeconds(-1);

            toDateString = convertdate(toDate.valueOf(), false);
        }

        results.push({
            startString: fromDateString,
            endString: toDateString
        });

        // Increment the start Date by ${SUMMARY_DATA_NUM_WEEKS} for the next iteration of the while loop
        startDT = addWeeksToDate(startDT, SUMMARY_DATA_NUM_WEEKS);
    }

    return results;
}

/*
 * Given a date and number of weeks
 * Return the date, incremented by ${numWeeks}
 */
function addWeeksToDate(date, numWeeks) {
    let hours = 24 * 7 * numWeeks;  
    date.setHours(date.getHours() + hours)

    return date;
}